import {connect} from 'react-redux';

import {setMetadataCategoriesAction} from './Redux/CategoriesActions';
import CategoriesContainer from './CategoriesContainer';
import {CategoriesState} from './CategoriesTypes';

export type State = {qcMetadataCategories: CategoriesState}

export const mapState = (state: State) => {
    const {qcMetadataCategories} = state;
    
    return qcMetadataCategories;
};

export const mapDispatch = {
    setMetadataCategories: setMetadataCategoriesAction,
};

export default connect(mapState, mapDispatch)(CategoriesContainer);
